import { HowToJsonLd } from 'next-seo';
import Line from '../../../images/curved-dotted-line.svg';
import Image from 'components/Image';
import { howToSteps } from './nameIdeasContent';

const PAGE_URL =
  'https://travelfeed.com/tools/travel-blog-name-ideas-generator';

export default function HowTo() {
  return (
    <>
      <HowToJsonLd
        name="How to Come Up With a Travel Blog Name"
        step={howToSteps.map((step, index) => ({
          type: 'HowToStep',
          name: step.name,
          url: `${PAGE_URL}#how-to-step-${index + 1}`,
          itemListElement: [{ type: 'HowToDirection', text: step.text }],
        }))}
      />
      <section className="tw-py-10 tw-bg-gray-50 sm:tw-py-16 lg:tw-py-24">
        <div className="tw-px-4 tw-mx-auto tw-max-w-7xl sm:tw-px-6 lg:tw-px-8">
          <div className="tw-max-w-2xl tw-mx-auto tw-text-center">
            <h2 className="tw-text-2xl tw-font-bold tw-leading-tight tw-text-gray-900 sm:tw-text-3xl lg:tw-text-4xl">
              How to Come Up With a Travel Blog Name
            </h2>
            <p className="tw-max-w-lg tw-mx-auto tw-mt-4 tw-text-base tw-leading-relaxed tw-text-gray-600">
              Three steps from blank page to a name you can claim today.
            </p>
          </div>

          <div className="tw-relative tw-mt-12 lg:tw-mt-20">
            <div className="tw-absolute tw-inset-x-0 tw-hidden xl:tw-px-44 tw-top-2 md:tw-block md:tw-px-20 lg:tw-px-28">
              <Image className="tw-w-full" src={Line} alt="" unoptimized />
            </div>

            <div className="tw-relative tw-grid tw-grid-cols-1 tw-text-center tw-gap-y-12 md:tw-grid-cols-3 tw-gap-x-12">
              {howToSteps.map((step, index) => (
                <div key={step.name} id={`how-to-step-${index + 1}`}>
                  <div className="tw-flex tw-items-center tw-justify-center tw-w-16 tw-h-16 tw-mx-auto tw-bg-white tw-border-2 tw-border-gray-200 tw-rounded-full tw-shadow">
                    <span className="tw-text-xl tw-font-semibold tw-text-gray-700">
                      {index + 1}
                    </span>
                  </div>
                  <h3 className="tw-mt-6 tw-text-xl tw-font-semibold tw-leading-tight tw-text-gray-900 md:tw-mt-10">
                    {step.name}
                  </h3>
                  <p className="tw-mt-4 tw-text-base tw-text-gray-600">
                    {step.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
